import { Tabs as MuiTab, withStyles } from '@material-ui/core'
import { PRIMARY_COLORS } from '../colors.constant'

const Tabs = withStyles({
  root: {
    minHeight: 32
  },
  flexContainer: {
    gap: 42
  },
  indicator: {
    backgroundColor: PRIMARY_COLORS[700]
  }
})(MuiTab)
export default Tabs
